import { FC } from "react";

import { ModalPortal } from "@livechat/design-system-react-components";

import ConfirmActionModal from "components/modals/ConfirmActionModal";
import { StackingContextLevel } from "styles/stacking-context-level";

interface IProps {
  onClose: () => void;
  confirmClose: () => void;
}

export const ConfirmCloseModal: FC<IProps> = ({ onClose, confirmClose }) => (
  <ModalPortal zIndex={StackingContextLevel.Modal}>
    <ConfirmActionModal
      heading="Your domain isn't added yet"
      onClose={confirmClose}
      primaryAction={{
        label: "Back to adding",
        onClick: onClose,
        actionType: "primary",
      }}
      secondaryAction={{
        label: "I'll do it later",
        onClick: confirmClose,
      }}
    >
      Finish adding your domain now to make your next messages credible.
    </ConfirmActionModal>
  </ModalPortal>
);
